module.exports = __webpack_public_path__ + "static/media/guide5.cdf7185f.png";